<template>
	<div>
	    <a @click="openManual" class="pull-right own-tooltip" style="font-size: 15px"><strong> <i class="fa fa-question-circle-o" /></strong> <span class="tooltiptext tooltip-top">Hilfe</span></a>
<!-- 	    <div class="clearfix" /> -->
    </div>
</template>

<script>
import {popupCenter} from '@/javascript/misc.js'
export default {
    name: "Help",
    props: ['section'],
    methods: {
        openManual () {
            let manual = this.$router.resolve({path: '/manual/'+this.section});
            //window.open(manual.href, "_blank");
            popupCenter(manual.href, "Anleitung", 1550, 700)
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/globals/Help.vue